export function getSrc(src: string): string {
  return src && src.indexOf("null") === -1 && src.indexOf("undefined") === -1
    ? src
    : "/static/default_thumbnail.png";
}
